import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { IconProps } from "./types";

export function ChevronBottomIcon({ size, ...props }: IconProps) {
    return <ExpandMoreRoundedIcon fontSize={size} {...props} />;
}
